// extracted by mini-css-extract-plugin
export default {"wrapper":"bottom-slot_wrapper__STjiZ","mobile":"bottom-slot_mobile__XqC+J","responsive":"bottom-slot_responsive__obNRA"};